import { useEffect, useState } from "react";
import { getAllCountries } from "../services/guest";

export const useCountryOptions = () => {
  const [countryOptions, setCountryOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCountries = async () => {
    setLoading(true);
    try {
      const response = await getAllCountries();
      const countries = response?.data || [];
      setCountryOptions(countries);
    } catch (error) {
      console.error("Error fetching countries", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  return { countryOptions, loading, fetchCountries };
};
